/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {
    IndividualWinPresentationController
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {FITHGameAssets} from "./FITHGameAssets";
import {FITHSoundConfig} from "./FITHSoundConfig";
import {FITHGameConfig} from "./FITHGameConfig";
import {FITHParsedInitData} from "./server/data/FITHParsedInitData";
import {FITHParsedGameData} from "./server/data/FITHParsedGameData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {AvalancheZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/AvalancheZeroBetController";
import {FITHReelFrameView} from "./views/FITHReelFrameView";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {
    BetWayWinIndividualWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {FITHBigWinController} from "./winpresentation/bigwin/FITHBigWinController";
import {FITHInitialWPController} from "./winpresentation/initial/FITHInitialWPController";
import {FITHReelSymbolStateCreator} from "./symbols/FITHReelSymbolStateCreator";
import {FITHReelSymbol} from "./symbols/FITHReelSymbol";
import {FITHAvalancheReelPartAnimator} from "./reel/FITHAvalancheReelPartAnimator";
import {FITHServerDataParser} from "./server/FITHServerDataParser";
import {IFITHGameData, IFITHInitData} from "./server/data/IFITHServerData";
import {FITHWinWaysBoardView} from "./views/FITHWinWaysBoardView";
import {FITHSymbolWinAnimations} from "./symbols/FITHSymbolWinAnimations";
import {FITHSpinController} from "./spin/FITHSpinController";
import {FITHAvalancheReelController} from "./reel/FITHAvalancheReelController";
import {FITHReelBackgroundView} from "./views/FITHReelBackgroundView";
import {FITHLogoView} from "./views/FITHLogoView";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {FITHFreeSpinIntroView} from "./screens/freeSpinIntro/FITHFreeSpinIntroView";
import {FITHFreeSpinOutroView} from "./screens/freeSpinOutro/FITHFreeSpinOutroView";
import {FITHFreeSpinZeroBetController} from "./zeroBet/FITHFreeSpinZeroBetController";
import {FITHFreeSpinOutroController} from "./screens/freeSpinOutro/FITHFreeSpinOutroController";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {FITHBackground} from "./background/FITHBackground";
import {FITHAnticipationView} from "./views/FITHAnticipationView";
import {
    ReelStopPresentationController
} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {FITHAnticipationController} from "./reelStopPresentation/FITHAnticipationController";
import {CoinsFountain} from "./views/CoinsFountain";
import {FITHBonusGameWagonAnimationsView} from "./views/FITHBonusGameWagonAnimationsView";
import {FITHReelAreaView} from "./reel/reelArea/FITHReelAreaView";
import {FITHReels} from "./reel/reelArea/FITHReels";
import {
    FITHBonusGameReelStopPresentationController
} from "./reelStopPresentation/FITHBonusGameReelStopPresentationController";
import {FITHBonusGameVSymOverlayView} from "./views/FITHBonusGameVSymOverlayView";
import {FITHWildMiningController} from "./winpresentation/wildMining/FITHWildMiningController";
import {FITHWaysWonGFXText} from "./winpresentation/initial/FITHWaysWonGFXText";
import {FITHWildMultiplierView} from "./views/FITHWildMultiplierView";
import {FITHSoundManager} from "./sound/FITHSoundManager";
import {FITHLogoIdleAnimationController} from "./idleAnimation/FITHLogoIdleAnimationController";
import {FeaturePrice} from "./utils/FeaturePrice";
import {IGameData, IInitData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";

export class FITHGameModuleConfig implements IGameModuleConfig {
    public static instance: FITHGameModuleConfig = new FITHGameModuleConfig();
    public static background: FITHBackground;
    public static reelBackgroundView: FITHReelBackgroundView;
    public static reelFrameView: FITHReelFrameView;
    public static winWaysBoard: FITHWinWaysBoardView;
    public static symbolWinAnimations: FITHSymbolWinAnimations;
    public static logoView: FITHLogoView;
    public static anticipationView: FITHAnticipationView;
    public static coinsFountain: CoinsFountain;
    public static bonusGameVSymbolOverlayView: FITHBonusGameVSymOverlayView;
    public static bonusGameSpinNWagonAnimations: FITHBonusGameWagonAnimationsView;
    public static reelAreaView: FITHReelAreaView;
    public static reels: FITHReels;
    public static spinController: FITHSpinController;
    public static bonusGameReelStop: FITHBonusGameReelStopPresentationController;
    public static waysWonGfx: FITHWaysWonGFXText;
    public static wildMultiplierView: FITHWildMultiplierView;
    public static featurePrice: FeaturePrice;

    GAME_CONFIG: IGameConfig = FITHGameConfig.instance;
    SOUND_CONFIG: ISoundConfig = FITHSoundConfig.instance;
    FONTS_CONFIG: IFontsConfig = {};
    RESOURCES_CONFIG: IResourcesGroupConfig = FITHGameAssets.RESOURCES_GROUPS;
    ZERO_BETS: (() => ZeroBetController)[] = [
        () => new AvalancheZeroBetController(),
        () => new FITHFreeSpinZeroBetController()
    ];
    WIN_PRESENTATIONS: ((indexes: [number, number]) => WinPresentationController)[][] = [
        [indexes => new FITHInitialWPController(indexes)],
        [indexes => new FITHBigWinController(indexes)],
        [indexes => new FITHWildMiningController(indexes)]
    ];
    SCREENS: (() => ScreenController)[] = [
        () => {
            return new FreespinIntroController({
                viewCreator: (onButtonClickCallback: () => void, autoClose?: boolean) => {
                    return new FITHFreeSpinIntroView({
                        layer: FITHGameConfig.instance.LAYERS.FREESPIN.name,
                        onButtonClickCallback: onButtonClickCallback,
                        buttonBackgroundConfig: {
                            cornerRadius: 12,
                            lineThickness: 2,
                            lineColor: 0xffffff,
                            lineAlpha: 1,
                            backgroundColor: 0x000000,
                            backgroundAlpha: 0.9
                        }
                    }, false);
                }
            });
        },
        () => {
            return new FITHFreeSpinOutroController({
                viewCreator: (onButtonClickCallback: () => void, autoClose?: boolean) => {
                    return new FITHFreeSpinOutroView({
                        layer: FITHGameConfig.instance.LAYERS.FREESPIN.name,
                        onButtonClickCallback: onButtonClickCallback,
                        buttonBackgroundConfig: {
                            cornerRadius: 12,
                            lineThickness: 2,
                            lineColor: 0xffffff,
                            lineAlpha: 1,
                            backgroundColor: 0x000000,
                            backgroundAlpha: 0.9
                        }
                    }, false);
                }
            });
        }
    ];
    REEL_STOP_PRESENTATIONS: ((index: number) => ReelStopPresentationController)[] = [
        index => new FITHAnticipationController(index, "FITHAnticipationController"),
        index => {
            return FITHGameModuleConfig.bonusGameReelStop = new FITHBonusGameReelStopPresentationController(index, "FITHBonusGameReelStopPresentationController")
        }
    ];

    constructor() {
        if (FITHGameModuleConfig.instance) {
            throw new Error("FITHGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    PARSED_INIT_DATA: (data: IInitData, dataParser: ServerDataParser) => ParsedInitData = (data: IInitData, dataParser: ServerDataParser) => {
        return new FITHParsedInitData(<IFITHInitData>data, <FITHServerDataParser>dataParser);
    };

    PARSED_GAME_DATA: (data: IGameData, dataParser: ServerDataParser) => ParsedGameData = (data: IGameData, dataParser: ServerDataParser) => {
        return new FITHParsedGameData(<IFITHGameData>data, <FITHServerDataParser>dataParser);
    };

    SERVER_PARSER: () => FITHServerDataParser = () => new FITHServerDataParser();

    REELS: () => FITHReels = () => {
        return FITHGameModuleConfig.reels = new FITHReels();
    }

    REEL_AREA_VIEW: () => FITHReelAreaView = () => {
        return FITHGameModuleConfig.reelAreaView = new FITHReelAreaView();
    }

    REEL_CONTROLLER: (reelId: number) => FITHAvalancheReelController = (reelId: number) => new FITHAvalancheReelController(reelId);

    REEL_PART_ANIMATOR: (reelId: number) => FITHAvalancheReelPartAnimator = (reelId: number) => new FITHAvalancheReelPartAnimator(reelId);

    REEL_PART_CREATOR: () => ReelPartCreator = () => new ReelPartCreator(
        (symName: string, reelId: number, state?: ISymbolStateConfig, size?: ISymbolSizeConfig): FITHReelSymbol => new FITHReelSymbol(symName, reelId, state, size));

    SYMBOL_STATE_CREATOR: () => ReelSymbolStateCreator = () => new FITHReelSymbolStateCreator();

    INDIVIDUAL_WIN_PRESENTATION: () => IndividualWinPresentationController = () => {
        return new BetWayWinIndividualWPController({
            symbolTimeOffsetCalculator: (currentTotalDuration: number, reelId: number, symbolId: number): number => {
                return 0;
            }
        });
    };

    SPIN_CONTROLLER: () => FITHSpinController = () => {
        return FITHGameModuleConfig.spinController = new FITHSpinController();
    }

    GAME_FEATURE_CREATOR: () => void = () => {
        new FITHSoundManager();

        FITHGameModuleConfig.background = new FITHBackground({
            layer: FITHGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages: {
                NORMAL: {image: FITHGameAssets.MAIN_GAME_BACKGROUND, offset: new PIXI.Point(-480, -480)},
                NORMAL_AVALANCHE: {image: FITHGameAssets.MAIN_GAME_BACKGROUND, offset: new PIXI.Point(-480, -480)},
                BONUS: {image: FITHGameAssets.MAIN_GAME_BACKGROUND, offset: new PIXI.Point(-480, -480)}
            },
            stretch: false
        });

        FITHGameModuleConfig.reelBackgroundView = new FITHReelBackgroundView();

        FITHGameModuleConfig.reelFrameView = new FITHReelFrameView();

        FITHGameModuleConfig.winWaysBoard = new FITHWinWaysBoardView();

        FITHGameModuleConfig.symbolWinAnimations = new FITHSymbolWinAnimations();

        FITHGameModuleConfig.logoView = new FITHLogoView();

        FITHGameModuleConfig.anticipationView = new FITHAnticipationView();

        FITHGameModuleConfig.coinsFountain = new CoinsFountain();

        FITHGameModuleConfig.bonusGameVSymbolOverlayView = new FITHBonusGameVSymOverlayView();

        FITHGameModuleConfig.bonusGameSpinNWagonAnimations = new FITHBonusGameWagonAnimationsView();

        FITHGameModuleConfig.wildMultiplierView = new FITHWildMultiplierView();

        new FITHLogoIdleAnimationController();

        FITHGameModuleConfig.featurePrice = new FeaturePrice();
    };
}